import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/components/AuthContext';

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Session invalide');
          navigate('/auth');
          return;
        }

        // Process the session
        await processGoogleCallback(sessionId);
        toast.success('Connexion réussie !');
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Erreur de connexion');
        navigate('/auth');
      }
    };

    processCallback();
  }, [location.hash, navigate, processGoogleCallback]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
          className="w-16 h-16 mx-auto mb-6 rounded-full bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center"
        >
          <Sparkles className="h-8 w-8 text-white" />
        </motion.div>
        <h1 className="font-heading text-2xl mb-2">Connexion en cours...</h1>
        <p className="text-muted-foreground">Veuillez patienter</p>
      </motion.div>
    </div>
  );
};

export default AuthCallbackPage;
